import { SsoConnectionAddParametersDomain } from '@mews-commander/data-access';
import { Table, TableProvider, useTableState } from '@optimus-web/core';
import { useSsoDomainColumns } from './ConfigureSsoPanelEnforcedDomainsTableMapping';

export interface ConfigureSsoPanelEnforcedDomainsTableProps {
    activeDomains: string[];
    enforcedDomains: Record<string, boolean>;
    onChange: (value: Record<string, boolean>) => void;
}

export function ConfigureSsoPanelEnforcedDomainsTable({
    activeDomains,
    enforcedDomains,
    onChange,
}: ConfigureSsoPanelEnforcedDomainsTableProps) {
    const [tableState, setTableState] = useTableState<SsoConnectionAddParametersDomain>({
        pagination: { show: false },
    });
    const { data, updateDomain } = useTableData({ activeDomains, enforcedDomains, onChange });
    const columns = useSsoDomainColumns({ onDomainChange: updateDomain });

    return (
        <TableProvider columns={columns} state={tableState} onStateChange={setTableState} as="div">
            <Table uniqueRowId="domain" amountOfRows={data.length} data={data} fixedFirstColumn fixedHeader />
        </TableProvider>
    );
}

function useTableData({ activeDomains, enforcedDomains, onChange }: ConfigureSsoPanelEnforcedDomainsTableProps) {
    const data: SsoConnectionAddParametersDomain[] = activeDomains.map((domain) => ({
        domain,
        enforceSingleSignOn: enforcedDomains[domain],
    }));

    const updateDomain = (domain: string, enforceSingleSignOn: boolean) => {
        const newEnforcedDomains = { ...enforcedDomains, [domain]: enforceSingleSignOn };
        onChange(newEnforcedDomains);
    };

    return { data, updateDomain };
}
